<form class="edit-modal kw-dialog" (ngSubmit)="submit()" name="itemInputForm" id="itemInputForm" #itemInputForm="ngForm">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">{{this.item.id ? 'Update' : 'New'}} {{"Product" | tenantWords}}</h2>
      <div class="modal-subtitle">{{this.item.id ? this.item.name : 'Fields marked * are required'}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faCubes" class="section-icon"></fa-icon>
        <h3>{{"Product" | tenantWords}}</h3>
      </div>
      <div class="section-grid">
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input [(ngModel)]="this.item.name" [required]="isREPToken" matInput type="text" id="itemNameInput"
            name="itemNameInput">
          <button *ngIf="!isREPToken && this.item.name" matSuffix mat-icon-button aria-label="Clear" type="button"
            (click)="this.item.name = null">
            <fa-icon [icon]="faXmark"></fa-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input [(ngModel)]="this.item.description" matInput type="text" id="itemDescriptionInput"
            name="itemDescriptionInput">
          <button *ngIf="this.item.description" matSuffix mat-icon-button aria-label="Clear" type="button"
            (click)="this.item.description = null">
            <fa-icon [icon]="faXmark"></fa-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Crop Variety</mat-label>
          <mat-select [required]="isREPToken" name="selectedVariety" [(ngModel)]="this.item.varietyId">
            <mat-option *ngFor="let f of this.varieties" [value]="f.id">
              {{f.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Parent Item</mat-label>
          <mat-select name="selectedItem" [(ngModel)]="this.item.parentItemId">
            <mat-option *ngFor="let f of this.items" [value]="f.id">
              {{f.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Package Type</mat-label>
          <mat-select [required]="isREPToken" name="packageType" (selectionChange)="typeSelectionChange($event)"
            [(ngModel)]="this.item.packageTypeId">
            <mat-option *ngFor="let f of this.packageTypes" [value]="f.id">
              {{f.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section" *ngIf="this.item.attributes?.length">
      <div class="section-head">
        <fa-icon [icon]="faSliders" class="section-icon"></fa-icon>
        <h3>Attributes</h3>
      </div>
      <div class="section-grid">
        <ng-container *ngFor="let field of this.item.attributes">
          <mat-form-field *ngIf="getOptionsLength(field) == 0 && field.datatype == 'string'" appearance="outline">
            <mat-label>{{field.name}}</mat-label>
            <input [(ngModel)]="field.value" [required]="field.isRequired" matInput type="text"
              id="custField{{field.id}}" name="custField{{field.id}}">
            <button *ngIf="field.value" matSuffix mat-icon-button aria-label="Clear" type="button"
              (click)="field.value = ''">
              <fa-icon [icon]="faXmark"></fa-icon>
            </button>
          </mat-form-field>

          <mat-form-field *ngIf="getOptionsLength(field) == 0 && field.datatype == 'number'" appearance="outline">
            <mat-label>{{field.name}}</mat-label>
            <input [(ngModel)]="field.value" [required]="field.isRequired" matInput type="number"
              id="custField{{field.id}}" name="custField{{field.id}}">
            <button *ngIf="field.value" matSuffix mat-icon-button aria-label="Clear" type="button"
              (click)="ClearValue(field)">
              <fa-icon [icon]="faXmark"></fa-icon>
            </button>
          </mat-form-field>

          <mat-form-field *ngIf="getOptionsLength(field) > 0" appearance="outline">
            <mat-label>{{getFieldName(field)}}</mat-label>
            <mat-select [required]="field.isRequired" name="fieldOptions{{field.id}}" [(ngModel)]="field.value"
              id="custField{{field.id}}">
              <mat-option *ngFor="let w of getFieldOptions(field)" [value]="w.value">
                {{w.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <button *ngIf="this.item.id" mat-stroked-button class="danger-btn" type="button" (click)="deleteItem()">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Delete
    </button>
    <span class="footer-spacer"></span>
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="itemInputForm.invalid">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</form>
